import React from 'react';
import { FINAL_SALE_COPY } from '../../../constants';
import { ReturnPolicy } from '../../../generated/types/globalTypes';
import { ReturnPolicyHyperlink } from '../../ReturnPolicyInformation';

import './ProductDetailsFinalSaleInformation.scss';

interface Props {
  returnPolicy: ReturnPolicy | null;
}

export const ProductDetailsFinalSaleInformation: React.FC<Props> = ({ returnPolicy }) => {
  if (!returnPolicy) return null;

  if (returnPolicy !== ReturnPolicy.final_sale) return null;

  return (
    <ReturnPolicyHyperlink className="ProductDetailsFinalSaleInformation">
      {FINAL_SALE_COPY}
    </ReturnPolicyHyperlink>
  );
};
